import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Header from './components/Header';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './pages/Dashboard';
import Configuracoes from './pages/Configuracoes';
import Historico from './pages/Historico';
import Atendimento from './pages/Atendimento';
import Login from './pages/Login';
import Register from './pages/Register';
import ManageUsers from './pages/ManageUsers';
import ManageGroups from './pages/ManageGroups';
import MensagensPredefinidas from './pages/MensagensPredefinidas';

import './App.css';

// Componente interno que usa o contexto de auth
const AppContent = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="App">
      {isAuthenticated && <Header />}
      <main className={`main-content ${!isAuthenticated ? 'full-width' : ''}`}>
        <div className="content-wrapper">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route 
              path="/" 
              element={
                <ProtectedRoute adminOnly={true}>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/configuracoes" 
              element={
                <ProtectedRoute adminOnly={true}>
                  <Configuracoes />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/historico" 
              element={
                <ProtectedRoute adminOnly={true}>
                  <Historico />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/atendimento" 
              element={
                <ProtectedRoute>
                  <Atendimento />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/register" 
              element={
                <ProtectedRoute manageUsersOnly={true}>
                  <Register />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/manage-users" 
              element={
                <ProtectedRoute manageUsersOnly={true}>
                  <ManageUsers />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/manage-groups" 
              element={
                <ProtectedRoute adminOnly={true}>
                  <ManageGroups />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/mensagens-predefinidas" 
              element={
                <ProtectedRoute adminOnly={true}>
                  <MensagensPredefinidas />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </div>
      </main>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

function App() {
  return (
    <Router>
      <ThemeProvider>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
